import { createContext } from 'react';
import { alpha, createTheme } from '@mui/material/styles';

export const ColorModeContext = createContext({
  toggleColorMode: () => {},
});

const paletteTokens = {
  light: {
    mode: 'light',
    primary: {
      main: '#2563eb',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#7c3aed',
    },
    background: {
      default: '#f5f6fb',
      paper: '#ffffff',
    },
    text: {
      primary: '#101828',
      secondary: '#475467',
    },
  },
  dark: {
    mode: 'dark',
    primary: {
      main: '#5b8eff',
      contrastText: '#0b1424',
    },
    secondary: {
      main: '#c084fc',
    },
    background: {
      default: '#0f172a',
      paper: '#1e293b',
    },
    text: {
      primary: '#f8fafc',
      secondary: '#cbd5f5',
    },
  },
};

const baseOverrides = {
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter","Segoe UI","Roboto",system-ui,-apple-system,sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          paddingInline: 20,
        },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: 20,
        },
      },
    },
    MuiContainer: {
      defaultProps: { maxWidth: false },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 16,
          overflow: 'hidden',
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
        }),
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: ({ theme }) => ({
          fontWeight: 700,
          backgroundColor: theme.palette.background.default,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }),
        root: ({ theme }) => ({
          borderBottom: `1px solid ${theme.palette.divider}`,
        }),
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover td': {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'light' ? 0.03 : 0.06),
          },
        }),
      },
    },
  },
};

export const createAppTheme = (mode = 'light') =>
  createTheme({
    palette: paletteTokens[mode] ?? paletteTokens.light,
    ...baseOverrides,
  });
